var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.masonryGridRef,class:{
    row: true,
    [_vm.classes]: _vm.classes,
  }},_vm._l((_vm.columns),function(column,index){return _c('div',{key:index,staticClass:"column small-12 medium-6 large-3"},_vm._l((column),function(item,i){return _c('div',{key:i,class:{ ['opacity-0']: _vm.isLoading }},[_vm._t("default",null,{"item":item})],2)}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }